// ✅ characterNameMap.ts - 增强角色名映射（中/日/英名+假名+昵称+声优）
const characterNameMap: Record<string, string[]> = {
    chika: [
      'chika', '高海千歌', '千歌', 'ちか', 'ちかちゃん',
      '伊波杏樹', 'いなみあんじゅ', '杏樹', 'anjyu'
    ],
    riko: [
      'riko', '桜内梨子', '梨子', 'りこ', 'リリー', 'lily',
      '逢田梨香子', 'あいだりかこ', '梨香子', 'rikako'
    ],
    you: [
      'you', '渡辺曜', '曜', 'よう', '船长', '舰长', 'ヨーソロー',
      '斉藤朱夏', 'さいとうしゅか', '朱夏', 'shuka'
    ],
    ruby: [
      'ruby', '黒澤ルビィ', '黑泽露比', '露比', 'るびぃ', '小红',
      '降幡愛', 'ふるはたあい', '降幡', 'furihata'
    ],
    hanamaru: [
      'hanamaru', '国木田花丸', '花丸', 'ずら丸', 'ずら', 'zura',
      '高槻かなこ', 'たかつきかなこ', 'かなこ'
    ],
    yoshiko: [
      'yoshiko', '津島善子', '善子', 'よしこ', '堕天使', '小恶魔',
      '小恶魔善子', 'ヨハネ', 'yohane',
      '小林愛香', 'こばやしあいか', '爱香', 'あいきゃん', 'aikyan'
    ],
    kanan: [
      'kanan', '松浦果南', '果南', 'かなん', '泳装组',
      '諏訪ななか', 'すわななか', 'すわわ', '諏訪'
    ],
    dia: [
      'dia', '黒澤ダイヤ', '黑泽黛雅', '黛雅', 'だいや', '大小姐',
      '小宫有纱', 'こみやありさ', '有纱', 'arisa'
    ],
    mari: [
      'mari', '小原鞠莉', '鞠莉', 'まり', 'マリー', 'marie', '圣母',
      '鈴木愛奈', 'すずきあいな', '爱奈', 'あいにゃ', 'ainya'
    ]
  };
  
  export default characterNameMap;
  